/* eslint-disable @typescript-eslint/no-empty-object-type */
import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';

import { GRPC_ENVIRONMENT } from './environment.provider';

type GrpcConstructor<T = {}> = new (address: string, ...args: Array<any>) => T;

type TDomain = 'common' | 'mainApi' | 'main2Api' | 'userApi';

export function CommonGrpcContractFactory<T>(GrpcContractClient: GrpcConstructor<T>, _domain: TDomain = 'common') {
  return () => {
    const environment = inject(GRPC_ENVIRONMENT);
    const platformId = inject(PLATFORM_ID);
    let domain: string = environment.domain as string;
    if (isPlatformBrowser(platformId)) {
      const markDomain = sessionStorage.getItem('mark-domain');
      if (_domain === 'mainApi') {
        domain = environment.mainApidomain as string;
      }
      if (_domain === 'main2Api') {
        domain = environment.main2Apidomain as string;
      }
      if (_domain === 'userApi') {
        domain = environment.userApidomain as string;
      }
      if (markDomain) {
        domain = markDomain;
      }
    } else {
      if (_domain === 'mainApi') {
        domain = environment.mainApidomain as string;
      }
      if (_domain === 'main2Api') {
        domain = environment.main2Apidomain as string;
      }
      if (_domain === 'userApi') {
        domain = environment.userApidomain as string;
      }
    }
    return new GrpcContractClient(domain);
  };
}
